import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const CustomerIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="9" cy="8" r="3" /><path d="M3 20v-2a6 6 0 0 1 12 0v2zM16 5.5a3 3 0 0 1 0 5.5M17 14a5 5 0 0 1 4 5v1" />
    </g>
  </SvgIcon>
)

export default CustomerIcon
